import Icon from '../components/Icon.vue'

Icon.register({
  'grin-tongue-squint': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M293.1 374.6C278.7 368.1 262 376.8 258.5 392.2L256.7 400C254.6 409.2 241.5 409.2 239.4 400L237.6 392.2C234.1 376.8 217.4 368.1 203 374.6 202.1 375 203.3 374.4 184.1 384V447C184.1 482.2 212.1 511.5 247.2 511.9 282.9 512.4 312.1 483.5 312.1 447.9V383.9C292.6 374.3 293.9 375 293.1 374.6zM248 8C111 8 0 119 0 256 0 362.3 67 452.7 161 488 155.4 475.8 152 462.3 152 448V402.5C127.3 386.3 108.5 364.4 104.2 338.7 102.2 326.9 113.4 317.2 124.9 320.8 155.1 330.5 200 336 248 336S340.9 330.5 371.1 320.8C382.5 317.1 393.7 326.9 391.8 338.7 387.5 364.4 368.7 386.3 344 402.5V448C344 462.3 340.6 475.8 335 488 429 452.7 496 362.3 496 256 496 119 385 8 248 8zM214.2 218.3L134.2 266.3C122.7 273.1 110.2 258.7 118.8 248.3L152.4 208 118.8 167.7C110.2 157.4 122.6 142.8 134.2 149.7L214.2 197.7C221.9 202.4 221.9 213.6 214.2 218.3zM377.2 248.3C385.9 258.7 373.3 273.1 361.8 266.3L281.8 218.3C274 213.6 274 202.4 281.8 197.7L361.8 149.7C373.5 142.8 385.7 157.4 377.2 167.7L343.6 208 377.2 248.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-tongue-squint.js
// module id = KuEb
// module chunks = 144